import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";

@Component({
    selector: "public-layout",
    templateUrl: "./public-layout.component.html",
    styleUrls: ["./public-layout.component.scss"],
})
export class PublicLayoutComponent implements OnInit {
    public clearHeader: any;

    constructor(private store: Store<IAppState>, private route: ActivatedRoute) {
        this.store.dispatch(new ShowLoader(false));

        this.route.firstChild.data.subscribe(data => {
            this.clearHeader = data.clearHeader;
        });
    }

    ngOnInit(): void {}
}
